export default __webpack_public_path__ + "static/media/KanipakamdietieThree.78d7c8f1.png";